<template>
    <div class="txdd">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="txdd-ads" v-if="spu.delivery==1">
            <van-cell-group custom-class="goods-cell-group" :border="false">
                <van-cell is-link @click="toAddress">
                    <div class="ads-info" v-if="addressInfo">
                        <span>{{addressInfo.province}}{{addressInfo.city}}{{addressInfo.county}}</span>
                        <span style="font-weight: bold;">{{addressInfo.addressDetail}}</span>
                        <span>{{addressInfo.name}} {{addressInfo.adsPhone}}</span>
                    </div>
                    <div class="ads-info" v-else>
                        <span>添加地址</span>
                    </div>
                </van-cell>
            </van-cell-group>
        </div>
        <div style="background-color: #EEEEEE;padding: 5px 0px;margin: 0px 5px">
            <div class="zhongbu">
                <van-cell-group custom-class="goods-cell-group" :border="false">
                    <van-cell icon="shop-o">
                        <span style="font-size: 12px">{{deptName}}</span>
                    </van-cell>
                </van-cell-group>
                <div class="spu-item">
                    <van-card
                            :num="skuNum"
                            :price="sku.sellingPrice"
                            :origin-price="sku.costPrice"
                            :desc="sku.specs"
                            :title="spu.spuName"
                            :thumb="spu.coverImg"
                    />
                </div>
                <div style="width: 95%;margin: auto;margin-top: 18px">
                    <van-cell-group custom-class="goods-cell-group" :border="false">
                        <van-cell>
                            <div style="display: flex;flex-direction: row;justify-content: space-between">
                                <span style="font-size: 12px">配送方式</span>
                                <span style="font-size: 12px">{{spu.delivery==0?'到店自提':'快递发货'}}</span>
                            </div>
                        </van-cell>
                    </van-cell-group>
                </div>
                <div class="zhongbu">
                    <div style="width: 95%;margin: auto;">
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-cell>
                                <div style="display: flex;flex-direction: row;justify-content: space-between">
                                    <span style="font-size: 12px">商品金额</span>
                                    <span style="font-size: 12px">¥{{dje}}</span>
                                </div>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false" v-if="isPlus">
                            <van-cell>
                                <div style="display: flex;flex-direction: row;justify-content: space-between">
                                    <span style="font-size: 12px">PLUS会员</span>
                                    <span style="font-size: 12px">-¥{{plus}}</span>
                                </div>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-cell>
                                <div style="display: flex;flex-direction: row;justify-content: space-between">
                                    <span style="font-size: 12px">运费</span>
                                    <span style="font-size: 12px">¥0</span>
                                </div>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-coupon-cell
                                    icon="coupon-o"
                                    :coupons="coupons"
                                    :chosen-coupon="chosenCoupon"
                                    @click="showList = true"
                                    style="font-size: 12px;"
                            />
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-cell>
                                <div style="display: flex;flex-direction: row;justify-content: space-between">
                                    <span style="font-size: 12px">合计</span>
                                    <span style="font-size: 12px;color: #ff4d51">¥{{zje}}</span>
                                </div>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-cell>
                                <div style="display: flex;flex-direction: column;">
                                    <span style="font-size: 12px">备注</span>
                                    <el-input type="textarea" :rows="3"  size="mini" resize="none"  v-model="mark" show-word-limit maxlength="30">
                                    </el-input>
                                </div>
                            </van-cell>
                        </van-cell-group>
                    </div>
                </div>
            </div>
            <div style="background-color: #EEEEEE;padding: 5px 0px 0px 0px">
                <div class="zhongbu">
                    <div style="width: 95%;margin: auto;">
                        <van-radio-group v-model="payType" style="margin-top: 10px">
                            <van-radio :name="item.value" checked-color="#07c160" class="radio-btn" v-for="item in payTypes">
                                <div style="display: flex;flex-direction: row">
                                    <van-icon :class="'iconfont '+ item.tbIcon" size="16" style="color: red;display: block;margin-top: 2px;margin-right: 5px"/>
                                    <span>{{item.name}}<span style="margin-left: 5px;color: #F59004" v-if="item.name=='金豆支付'">{{mb.goldCoin}}</span></span>
                                </div>
                            </van-radio>
                        </van-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <van-submit-bar
                :loading="loading"
                :price="zje*100"
                button-text="结算"
                @submit="onSubmit"
        />
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";

    let adsId;
    export default {
        data() {
            return {
                title: '填写订单',
                deptName: '',
                token: '',
                deptId: '',
                adsId: '',
                skuId: '',
                addressInfo: {},
                payTypes: [
                    {'name': '微信支付', 'value': 0,'tbIcon':'icon-iwxpay'},
                    {'name': '金豆支付', 'value': 2,'tbIcon':'icon-jindou'},
                ],
                mb: {},
                skuNum: '',
                spu: {},
                sku: {},

                isPlus: false,
                dje: 0,
                zje: 0,
                plus: 0,
                mark:'',

                orderId: '',
                payType: 0,
                chosenCoupon: -1,
                coupons: [],
                showList: false,

                params: {},

                loading:false,
            };
        },
        beforeRouteEnter(to, from, next) {
            adsId = from.params.hasOwnProperty('adsId') ? from.params.adsId : ''
            next();
        },
        async created() {
            document.title = getDeptName()
            this.token = getCookie('spmToken')
            this.deptId = getDeptId()
            // this.adsId = this.$route.query.adsId
            this.skuId = this.$route.params.skuId
            this.skuNum = this.$route.params.skuNum
            if (adsId) {
                this.adsId = adsId
            }
            await this.getMember()
            await this.getAddress()
            await this.getSpuInfo()

        },
        methods: {

            async getAddress() {
                let data = {
                    adsId: this.adsId,
                    token: this.token
                }
                let res = await this.$get("/spm/getSpmAddressInfo", data)
                this.deptName = res.deptName
                this.addressInfo = res.info
                if (res.info && res.info.id) {
                    this.adsId = res.info.id
                }
            },

            async getSpuInfo() {
                let res = await this.$get("/spm/getSpmSpuInfo", {
                    skuId: this.skuId,
                    skuNum: this.skuNum,
                    token: this.token
                })
                this.spu = res.spu
                this.sku = res.sku
                this.dje = res.dje
                this.zje = res.zje
                this.isPlus = res.isPlus
                this.plus = res.plus
            },

            async getMember() {
                let res = await this.$get("/spm/getSpmMember", {token: this.token})
                this.mb = res.mb
            },

            onSubmit() {
                this.loading=true
                if (this.orderId){
                    if (this.payType == 0) {
                        this.zhifu(this.orderId)
                    }
                    if (this.payType == 2) {
                        this.notify(this.orderId, this.payType)
                    }
                    return;
                }
                this.saveOrder()
            },

            async saveOrder() {
                if (this.spu.delivery != 0) {
                    if (!this.adsId) {
                        this.$notify({
                            message: '请选择收货地址',
                            duration: 1000,
                            background: 'red'
                        });
                        return;
                    }
                }
                let data = {
                    skuNum: this.skuNum,
                    skuId: this.skuId,
                    adsId: this.adsId,
                    deptId: this.deptId,
                    delivery: this.spu.delivery,
                    payType: this.payType,
                    mark: this.mark,
                    token: this.token
                }
                let res = await this.$post("/spm/saveSpmOrder", data)
                if (res.code == 200) {
                    this.orderId = res.orderId
                    if (this.payType == 0) {
                        this.zhifu(this.orderId)
                    }
                    if (this.payType == 2) {
                        this.notify(this.orderId, this.payType)
                    }
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
                this.loading=false
            },
            async notify(orderId, payType) {
                let res = await this.$post('/spm/notify', {
                    orderId: orderId,
                    payType: payType
                })
                if (res.code == 200) {
                    this.$router.push('/success/' + this.deptId + '/' + this.spu.delivery)
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
            async zhifu(orderId) {
                let res = await this.$post('/api/unifiedOrder', {
                    orderId: orderId
                })
                this.params = res
                if (typeof WeixinJSBridge === 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(this.params), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(this.params))
                        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(this.params))
                    }
                } else {
                    this.onBridgeReady(this.params)
                }
            },

            onBridgeReady(params) {
                const that = this
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest',
                    {
                        appId: params.appId, // 公众号名称，由商户传入
                        timeStamp: params.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: params.nonceStr, // 支付签名随机串，不长于 32 位
                        package: params.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: params.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: params.paySign // 支付签名
                    },
                    function (res) {
                        if (res.err_msg == 'get_brand_wcpay_request:ok') {
                            that.$router.push('/success/' + that.deptId + '/' + that.spu.delivery)
                        }
                        // // 支付过程中用户取消
                        // if (res.err_msg == "get_brand_wcpay_request:cancel") {
                        //   this.$notify({
                        //     message: '取消支付',
                        //     duration: 1000,
                        //     background: 'red'
                        //   });
                        // }
                        if (res.err_msg == 'get_brand_wcpay_request:fail') {
                            that.$notify({
                                message: '支付失败',
                                duration: 1000,
                                background: 'red'
                            });
                        }
                    }
                )
            },

            //选择地址
            toAddress() {
                this.$router.push('/address/' + this.deptId)
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$route.params.skuId = this.skuId;
                    this.$route.params.skuNum = this.skuNum;
                    this.$router.back()
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    }
    ;
</script>

<style lang="scss" scoped>

    .txdd {
        padding-top: 46px;
        padding-bottom: 50px;
        overflow: scroll;
        background-color: #EEEEEE;
        height: 100%;
    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }

    ::v-deep .van-cell {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 5px 10px;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.64rem;
        background-color: #fff;
    }

    .van-cell__right-icon {
        margin: auto;
        margin-left: 0.10667rem;
        color: #969799;
    }

    .txdd-ads {
        height: 85px;
        background-color: #FFFFFF;
        padding: 0px 8px;
    }

    .ads-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 70px;
    }

    .ads-info span {
        font-size: 12px
    }

    .zhongbu {
        border-radius: 10px;
        padding: 8px 0px;
        background-color: #FFFFFF;
    }

    .spu-item {
        background-color: #FFFFFF;
        width: 90%;
        margin: auto;
    }

    .radio-btn {
        height: 40px;
        font-size: 14px;
    }

    ::v-deep .van-radio__icon {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -ms-flex: none;
        flex: none;
        height: 1em;
        font-size: 13px;
        line-height: 1em;
        cursor: pointer;
        position: relative;
        left: 90%;
    }
</style>
